import "./NavBar.css"
import { motion } from 'framer-motion';
import {Link} from 'react-scroll'
export default function NavBar(){
    return<> <ul className="MainNav" >
        <motion.li className="NavItem" initial={{
            y:-90
        }} animate={{
            y:0
        }}
        transition={{
            delay:0.1,
            duration:0.5
        }}
        ><Link to="aboutSection" smooth={true} duration={500}>About</Link></motion.li> 
        <motion.li 
        initial={{
            y:-90
        }} animate={{
            y:0
        }}
        transition={{
            delay:0.3,
            duration:0.5
        }}
        className="NavItem"><Link to="projectSection" smooth={true} duration={500}>Projects</Link></motion.li>
        <motion.li 
        initial={{
            y:-90
        }} animate={{
            y:0
        }}
        transition={{
            delay:0.5,
            duration:0.5
        }}
        className="NavItem"><Link to="educationSection" smooth={true} duration={500}>Education</Link></motion.li>
        <motion.li
        initial={{
            y:-90
        }} animate={{
            y:0
        }}
        transition={{
            delay:0.7,
            duration:0.5
        }}
        className="NavItem"><Link to="socialSection" smooth={true} duration={500}>Let's Connect</Link></motion.li>
    </ul>
    <div style={{
        display:"flex",
        alignItems:"start",
        justifyContent:"start",
        width:"100vw"
    }}>
    <motion.span className="menu" onClick={()=>{
       document.querySelector(".responsive").classList.toggle('mobile-menu')
    }} initial={{
        y:-70,
        opacity:0
    }} animate={{
        y:0,
        opacity:1
    }}>=</motion.span>
    <ul className="responsive">
        <li className="NavItemresponsive"><Link to="aboutSection" smooth={true} duration={500}>About</Link></li> 
        <li className="NavItemresponsive"><Link to="projectSection" smooth={true} duration={500}>Projects</Link></li>
        <li className="NavItemresponsive"><Link to="educationSection" smooth={true} duration={500}>Education</Link></li>
        <li className="NavItemresponsive"> <Link to="socialSection" smooth={true} duration={500}>Let's Connect</Link></li>
    </ul>
    </div>
    </>
}